module.exports = __webpack_public_path__ + "static/media/025-device.2d022555.svg";